import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const HttpV2ReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  const isGet = form.watch('properties.httpMethod') === 'GET';

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="httpV2ReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="httpV2ReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="httpV2ReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="httpV2ReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter parameterization"
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="httpV2ReaderFormPaginationType"
        label="paginationType"
        name="properties.paginationType"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.properties?.paginationType?.message}
      >
        <option value="QueryString">Query String</option>
        <option value="RequestBody">Request Body</option>
        <option value="Stream">Stream</option>
      </FormField>
      <FormField
        controlId="httpV2ReaderFormHttpMethod"
        label="httpMethod"
        name="properties.httpMethod"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        placeholder="Enter HTTP method"
        error={errors?.properties?.httpMethod?.message}
      >
        <option value="">Select HTTP Method</option>
        <option value="GET">GET</option>
        <option value="POST">POST</option>
        <option value="PUT">PUT</option>
        <option value="DELETE">DELETE</option>
      </FormField>
      <FormField
        controlId="httpV2ReaderFormUrl"
        label="url"
        name="properties.url"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter URL"
        error={errors?.properties?.url?.message}
      />
      <FormField
        controlId="httpV2ReaderFormAcceptInvalidCerts"
        label="acceptInvalidCerts"
        name="properties.acceptInvalidCerts"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="httpV2ReaderFormHeaders"
        label="headers"
        name="properties.headers"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
        placeholder="Enter headers"
        error={errors?.properties?.headers?.message}
        rows={10}
      />
      {!isGet && (
        <FormField
          controlId="httpV2ReaderFormBody"
          label="body"
          name="properties.body"
          control={formControl}
          fieldComponentType={FORM_FIELD_TYPES.JSON}
          placeholder="Enter body"
          error={errors?.properties?.body?.message}
          rows={10}
          disabled={isGet}
        />
      )}
      <FormField
        controlId="httpV2ReaderFormQueryString"
        label="queryString"
        name="properties.queryString"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Enter query string"
        error={errors?.properties?.queryString?.message}
        rows={10}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default HttpV2ReaderForm;
